import { render, staticRenderFns } from "./ApiDashboardWidget.vue?vue&type=template&id=98ea14f4"
import script from "./ApiDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ApiDashboardWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports